import React from 'react';
import { motion } from 'framer-motion';
interface DarkChatBubbleProps {
  text: string;
  author: string;
  delay?: number;
  side?: 'left' | 'right';
}
export function DarkChatBubble({
  text,
  author,
  delay = 0,
  side = 'left'
}: DarkChatBubbleProps) {
  return <motion.div initial={{
    opacity: 0,
    x: side === 'left' ? -50 : 50
  }} whileInView={{
    opacity: 1,
    x: 0
  }} viewport={{
    once: true
  }} transition={{
    duration: 0.6,
    delay
  }} className={`flex ${side === 'right' ? 'justify-end' : 'justify-start'} mb-6`} data-id="element-272">
      <div className="max-w-md bg-cosmic-darker border border-gold-primary border-opacity-30 rounded-2xl p-5 shadow-lg" style={{
      boxShadow: '0 0 15px rgba(201, 168, 76, 0.15)'
    }} data-id="element-273">
        <p className="text-gray-100 text-sm leading-relaxed mb-3" data-id="element-274">{text}</p>
        <p className="text-gold-light text-xs font-medium" data-id="element-275">— {author}</p>
      </div>
    </motion.div>;
}